'use client'

import { useEffect } from 'react'
import { loadCompleteDictionary } from '@/hooks/useI18n'
import { useI18nBootstrap } from '@/provider/I18nBootstrapProvider'

export default function DeferredI18nDictionaryLoader() {
  const bootstrap = useI18nBootstrap()

  useEffect(() => {
    if (!bootstrap || bootstrap.complete) return
    void loadCompleteDictionary(bootstrap.lang)
  }, [bootstrap])

  return null
}
